import React, { useState, createContext, useEffect, useContext, useMemo } from "react";
import API from "Util/Axios";
import { PermisosContext } from "components/Permisos/PermisosContext";

export const Context = createContext();

// The legacy keys come from the permisos context (GET permisos/me, or the
// user/policies fallback it runs for portal sessions), so <Policy> refreshes
// on the same schedule as the modular checks.
export const Provider = ({ children }) => {
  const permisos = useContext(PermisosContext);
  const [allPolicies, setAllPolcies] = useState([]);
  const [allLoading, setAllLoading] = useState(true);
  const [error, setError] = useState(null);

  const status = permisos?.status;
  const legacyKeys = permisos?.legacyKeys;

  useEffect(() => {
    API.get("policy")
      .then((response) => setAllPolcies(response.data))
      .catch((error) => {
        console.log("Policy ", error);
        setError(error);
        localStorage.removeItem("token");
        window.location.reload();
      })
      .finally(() => setAllLoading(false));
  }, []);

  useEffect(() => {
    if (status === "error") {
      setError(permisos.error);
      localStorage.removeItem("token");
      window.location.reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const ctx = useMemo(
    () => ({
      policies: legacyKeys || [],
      allPolicies: allPolicies,
      policy_error: error,
    }),
    [legacyKeys, allPolicies, error]
  );

  const loading = allLoading || status === undefined || status === "loading";

  return <Context.Provider value={ctx}>{loading ? "..." : children}</Context.Provider>;
};
